import { Graphics, TextMetrics } from 'pixi.js';
import { formatCurrencyValue } from '../../helper/currencies';
import { logger } from '@orbital/slot-lib';

const capitalizeWords = (str) => {
	let prize = str.split('_').join(' ');
	return prize.toUpperCase();
};

export function generateBonusGame(wrapper, GameConfigs, currency) {
	wrapper.PROMPT_DESC.text = 'YOUR NEXT SPIN WILL BE A';
	wrapper.PROMPT_PRIZE.text = capitalizeWords(
		GameConfigs.quest_claim.item.prize.type
	);
	wrapper.PROMPT_PRIZE_DESC.text = 'SPIN PRICE';
	wrapper.PROMPT_AMOUNT.text = formatCurrencyValue(
		GameConfigs.config.bet_steps[
			GameConfigs.quest_claim.bet_level !== ''
				? GameConfigs.quest_claim.bet_level
				: 0
		],
		currency
	);
}

export function generateBonusDiscount(wrapper, GameConfigs, currency) {
	let line = new Graphics();
	line.clear();
	line.lineStyle(3, 0xae8d32, 1);
	wrapper.PROMPT_TITLE.text = 'AS A QUEST REWARD';
	logger.log(
		GameConfigs.quest_claim.item.prize.config.discount,
		'GameConfigs.quest_claim.item.prize.config.discount'
	);
	wrapper.PROMPT_DESC.text = `YOU WILL GET ${GameConfigs.quest_claim.item.prize.config.discount}% DISCOUNTED`;
	wrapper.PROMPT_PRIZE_DESC_1.text = 'YOU WILL GET AT LEAST';
	wrapper.PROMPT_PRIZE_DESC_2.text = 'BONUS SPINS';
	wrapper.PROMPT_PRIZE_DESC_1.position.x = 195;

	wrapper.PROMPT_PRIZE.text = GameConfigs.config.minfs;

	const PROMPT_PRIZE_DESC_1_WIDTH = TextMetrics.measureText(
		wrapper.PROMPT_PRIZE_DESC_1.text,
		wrapper.PROMPT_PRIZE_DESC_1.style
	).width;
	wrapper.PROMPT_PRIZE.position.x = PROMPT_PRIZE_DESC_1_WIDTH + 82;
	wrapper.PROMPT_PRIZE_DESC_2.position.x = PROMPT_PRIZE_DESC_1_WIDTH + 190;
	wrapper.PROMPT_PRIZE_DESC.text = 'AT COST OF';
	const PROMPT_PRIZE_DESC_WIDTH = TextMetrics.measureText(
		wrapper.PROMPT_PRIZE_DESC.text,
		wrapper.PROMPT_PRIZE_DESC.style
	).width;
	wrapper.PROMPT_DESC.position.x = wrapper.getBounds().width / 2;

	const discountedPrice =
		GameConfigs.config.buyfeatureprice *
		GameConfigs.config.bet_steps[
			GameConfigs.quest_claim.bet_level !== ''
				? GameConfigs.quest_claim.bet_level
				: 0
		];

	wrapper.PROMPT_PRIZE_DISCOUNT.text = formatCurrencyValue(
		discountedPrice,
		currency
	);

	wrapper.PROMPT_PRIZE_DISCOUNT.position.x = wrapper.getBounds().width / 2;
	const amount =
		(discountedPrice * GameConfigs.quest_claim.item.prize.config.discount) /
		100;
	wrapper.PROMPT_AMOUNT.text = formatCurrencyValue(amount, currency);

	wrapper.PROMPT_PRIZE_DESC.position.x =
		wrapper.PROMPT_PRIZE_DISCOUNT.getBounds().x - PROMPT_PRIZE_DESC_WIDTH / 2;
	let x =
		wrapper.PROMPT_PRIZE_DISCOUNT.getBounds().width / 1.3 +
		wrapper.PROMPT_PRIZE_DISCOUNT.position.x;

	let y = wrapper.PROMPT_PRIZE_DISCOUNT.position.y + 15;
	line.moveTo(wrapper.PROMPT_PRIZE_DISCOUNT.position.x, y);
	line.lineTo(x, y);
	wrapper.addChild(line);
}

export function generateWildRespin(wrapper, GameConfigs, currency) {
	wrapper.PROMPT_DESC.text = `YOU WILL GET`;
	wrapper.PROMPT_PRIZE.text =
		GameConfigs.quest_claim.item.prize.count -
		GameConfigs.quest_claim.item.claimed;
	if (
		GameConfigs.quest_claim.item.prize.count -
			GameConfigs.quest_claim.item.claimed >
		9
	) {
		wrapper.PROMPT_PRIZE.position.x = wrapper.getBounds().width / 2 - 84;
	} else {
		wrapper.PROMPT_PRIZE.position.x = wrapper.getBounds().width / 2 - 72;
	}
	wrapper.PROMPT_PRIZE_DESC_2.text = 'WILD SPINS';
	wrapper.PROMPT_PRIZE_DESC_2.position.x = wrapper.getBounds().width / 2 + 22;
	wrapper.PROMPT_PRIZE_DESC.text = 'SPIN PRICE';
	wrapper.PROMPT_AMOUNT.text = formatCurrencyValue(
		GameConfigs.config.bet_steps[GameConfigs.quest_claim.bet_level],
		currency
	);
}

export function generateWinMultiplier(wrapper, GameConfigs, currency) {
	wrapper.PROMPT_DESC.text = `YOU WILL GET ${GameConfigs.quest_claim.item.prize.config.multiplier}X WIN ON`;
	wrapper.PROMPT_PRIZE.text =
		GameConfigs.quest_claim.item.prize.count -
		GameConfigs.quest_claim.item.claimed;
	wrapper.PROMPT_PRIZE.anchor.x = 1;
	wrapper.PROMPT_PRIZE.position.x = wrapper.getBounds().width / 2;
	wrapper.PROMPT_PRIZE_DESC_2.text = 'SPINS';
	wrapper.PROMPT_PRIZE_DESC_2.position.x =
		wrapper.PROMPT_PRIZE.getBounds().x +
		wrapper.PROMPT_PRIZE.getBounds().width +
		25;
	wrapper.PROMPT_PRIZE_DESC.text = 'SPIN PRICE';
	wrapper.PROMPT_AMOUNT.text = formatCurrencyValue(
		GameConfigs.config.bet_steps[GameConfigs.quest_claim.bet_level],
		currency
	);
}

export function generateBetDiscount(wrapper, GameConfigs, currency) {
	let line = new Graphics();
	line.clear();
	line.lineStyle(3, 0x29c6c8, 1);
	wrapper.PROMPT_DESC.text = `YOU WILL GET ${GameConfigs.quest_claim.item.prize.config.discount}% DISCOUNTED`;
	wrapper.PROMPT_PRIZE.text =
		GameConfigs.quest_claim.item.prize.count -
		GameConfigs.quest_claim.item.claimed;
	wrapper.PROMPT_PRIZE.anchor.x = 1;
	wrapper.PROMPT_PRIZE.position.x = wrapper.getBounds().width / 2;
	wrapper.PROMPT_PRIZE_DESC_2.text = 'SPINS';
	wrapper.PROMPT_PRIZE_DESC_2.position.x =
		wrapper.PROMPT_PRIZE.getBounds().x +
		wrapper.PROMPT_PRIZE.getBounds().width +
		25;
	wrapper.PROMPT_PRIZE_DESC.text = 'SPIN PRICE';
	wrapper.PROMPT_PRIZE_DESC.position.x = wrapper.getBounds().width / 2 - 30;

	const PROMPT_PRIZE_DESC_WIDTH = TextMetrics.measureText(
		wrapper.PROMPT_PRIZE_DESC.text,
		wrapper.PROMPT_PRIZE_DESC.style
	).width;
	wrapper.PROMPT_PRIZE_DISCOUNT.text = formatCurrencyValue(
		GameConfigs.config.bet_steps[GameConfigs.quest_claim.bet_level],
		currency
	);
	wrapper.PROMPT_PRIZE_DISCOUNT.alpha = 0.5;
	const amount =
		GameConfigs.config.bet_steps[GameConfigs.quest_claim.bet_level] -
		(GameConfigs.config.bet_steps[GameConfigs.quest_claim.bet_level] *
			GameConfigs.quest_claim.item.prize.config.discount) /
			100;
	wrapper.PROMPT_PRIZE_DISCOUNT.position.x =
		wrapper.PROMPT_PRIZE_DESC.getBounds().x + PROMPT_PRIZE_DESC_WIDTH + 10;
	wrapper.PROMPT_AMOUNT.text = formatCurrencyValue(amount, currency);
	let x =
		wrapper.PROMPT_PRIZE_DISCOUNT.getBounds().width / 1.4 +
		wrapper.PROMPT_PRIZE_DISCOUNT.position.x;
	let y = wrapper.PROMPT_PRIZE_DISCOUNT.position.y + 15;
	line.moveTo(wrapper.PROMPT_PRIZE_DISCOUNT.position.x, y);
	line.lineTo(x, y);
	wrapper.addChild(line);
}
